import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42ab147e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-text" }, "Tap to refresh.", -1))

import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { faCircleExclamation } from 'fontawesome/pro-regular-svg-icons'

interface Props {
    type: 'page' | 'section'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddlesError',
  props: {
    type: {}
  },
  emits: ['onErrorClick'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const onErrorClick = () => {
    emit('onErrorClick')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "huddles-card huddles-error-card",
    onClick: onErrorClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faCircleExclamation) }, null, 8, ["icon"]),
      _createTextVNode(" Failed to load this " + _toDisplayString(_ctx.type), 1)
    ]),
    _hoisted_2
  ]))
}
}

})